import type { PropsOf } from '@emotion/react'
import type { FC } from 'react'
import { useParams } from 'react-router-dom'

import New from '@app/pages/strategies/components/aiChat/new'

type Props = Omit<PropsOf<typeof New>, 'strategyId' | 'chattableType' | 'chattableId'>

const RoutedNew: FC<Props> = (props) => {
  const { strategyId } = useParams()

  return <New strategyId={strategyId} chattableId={strategyId} chattableType="strategy" {...props} />
}

export default RoutedNew
